<template>
  <div>
    <SysAdmins v-if="$_hasRole('sysAdmin')" />
    <SchoolAdmins v-else-if="$_hasRole('schoolAdmin')" />
    <div v-else>
      <v-alert type="error" prominent border="left"
        >Sie haben keine Berechtigung, diese Seite zu sehen.</v-alert
      >
    </div>
  </div>
</template>
<script>
import { defineComponent } from "vue";
import SysAdmins from "./SysAdmins.vue";
import SchoolAdmins from "./SchoolAdmins.vue";
export default defineComponent({
  name: "Impersonation",
  components: {
    SchoolAdmins,
    SysAdmins,
  },
});
</script>
